import { ApiTargetGroupsService } from "../../services/api-target-groups.service";
import { patchState, signalStore, withHooks, withMethods } from "@ngrx/signals";
import { setAllEntities, setEntity, withEntities } from "@ngrx/signals/entities";
import { setFulfilled, setPending, withRequestStatus } from "../extensions/request-status.feature";
import { inject } from "@angular/core";
import { rxMethod } from "@ngrx/signals/rxjs-interop";
import { pipe, switchMap, tap } from "rxjs";
import { TargetGroupViewModel } from "@playcharge/common/models/backend/target-groups/target-group-view-model";

export type TargetGroupsStore = InstanceType<typeof TargetGroupsStore>;

export const TargetGroupsStore = signalStore(
    { providedIn: "root", protectedState: false },
    withEntities<TargetGroupViewModel>(),
    withRequestStatus(),
    withMethods((store, apiTargetGroupsService = inject(ApiTargetGroupsService)) => ({
        setGroup(group: TargetGroupViewModel): void {
            patchState(store, setEntity(group));
        },
        loadGroups: rxMethod<void>(
            pipe(
                tap(() => patchState(store, setPending())),
                switchMap(() => {
                    return apiTargetGroupsService.getAll().pipe(
                        tap((targetGroups) => {
                            patchState(store, setAllEntities(targetGroups));
                            patchState(store, setFulfilled());
                        }),
                    );
                }),
            ),
        ),
    })),
    withHooks((store) => ({
        onInit: () => {
            store.loadGroups();
        },
    })),
);
